import { useGeoServerFeaturesList } from "@l2r-front/l2r-geodata"

import { useNetworksStateContext } from "../contexts/NetworksContext"

import { networksQueryKeys } from "./queryKeys"
import { useExtendWithSubnetworks } from "./useExtendWithSubnetworks"

export function useNetworkReferential(queryParameters = {}, config = {}, subNetworks = null) {
    const { selectedNetwork } = useNetworksStateContext()
    const parameters = useExtendWithSubnetworks({
        ...queryParameters,
        layer: selectedNetwork.referential.layerSection,
        as_geojson: true,
        with_properties: false,
    }, null, "sub_network_slugs", subNetworks)
    const queryKey = networksQueryKeys.referential(selectedNetwork.slug, parameters)

    return useGeoServerFeaturesList(queryKey, parameters, config)
}
